import { authenticatedFetch } from '../utils/api';
import { API_HOST } from '../utils/constants';

export const fetchPublicVisualReferences = (filters = {}) => {
  const query = new URLSearchParams();
  ['q', 'category', 'mediaType', 'market'].forEach((key) => {
    if (filters[key] != null && filters[key] !== '') {
      query.set(key, filters[key]);
    }
  });
  return authenticatedFetch(`${API_HOST}/api/visual-references${query.toString() ? `?${query}` : ''}`);
};
